import React from 'react';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

const MultilineInput = React.forwardRef(function MultilineInput(
  { value, onChange, onFocus, sx },
  ref
) {
  return (
    <TextField
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      multiline
      fullWidth
      variant="outlined"
      inputRef={ref}
      sx={{
        '.MuiOutlinedInput-root': {
          backgroundColor: '#fff',
          padding: '18px 22px',
          alignItems: 'flex-start',

          '& fieldset': {
            borderRadius: '4px',
            borderWidth: 2,
            borderColor: '#5D6F92'
          },
          '&:hover fieldset': {
            borderWidth: 2,
            borderColor: '#5D6F92'
          },
          '&.Mui-focused fieldset': {
            borderWidth: 2,
            borderColor: '#5D6F92'
          },

          '& .MuiOutlinedInput-inputMultiline': {
            padding: 0,
            fontSize: 22,
            lineHeight: 1.6,
            fontWeight: 500,
            color: '#1F2A44',
            caretColor: '#1F2A44'
          }
        },

        '& .MuiFormHelperText-root': {
          marginLeft: 0
        },

        ...sx
      }}
    />
  );
});

MultilineInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  sx: PropTypes.shape()
};

export default MultilineInput;
